import { Templates } from '@hellohair/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NextQuestionSelect, StepField } from '../_shared/fields';
import { ModalList } from '../_shared/ModalList';
import { StepDialog, StepEditorProps } from '../_shared/StepDialog';
import { useStepDraft } from '../_shared/useStepDraft';

/**
 * A slide that only shows something. It records no answer, so it never appears
 * in the stored survey or the doctor's copy - `body` is deliberately free HTML.
 */
const Interstitial: FC<StepEditorProps> = ({ survey, index, onClose }) => {
  const { t } = useTranslation();
  const { draft, set, save, dirty } = useStepDraft<Templates.StepDataInterstitial>(survey, index);
  const modals: Templates.RichTextModal[] = Array.isArray(draft.modals) ? draft.modals : [];

  return (
    <StepDialog
      survey={survey}
      index={index}
      onSave={save}
      onClose={onClose}
      dirty={dirty}
      edit={
        <>
          <StepField
            label={t('editor.field.eyebrow')}
            value={draft.eyebrow}
            onChange={(value) => set('eyebrow', value)}
            helperText={t('editor.hint.eyebrow')}
          />
          <StepField
            label={t('editor.field.headline')}
            value={draft.question}
            onChange={(value) => set('question', value)}
            multiline
          />
          <StepField
            label={t('editor.field.lead')}
            value={draft.extra}
            onChange={(value) => set('extra', value)}
            multiline
          />
          <StepField
            label={t('editor.field.body')}
            value={draft.body}
            onChange={(value) => set('body', value)}
            multiline
            helperText={t('editor.hint.body')}
          />

          <ModalList modals={modals} onChange={(next) => set('modals', next)} />
        </>
      }
      logic={
        <NextQuestionSelect
          steps={survey.steps}
          value={draft.followerId}
          onChange={(followerId) => set('followerId', followerId)}
        />
      }
      settings={
        <StepField label={t('editor.field.buttonLabel')} value={draft.next} onChange={(value) => set('next', value)} />
      }
    />
  );
};

export default Interstitial;
